// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class AnnouncementType {
    public static readonly SUCCESS: number = 1;
    public static readonly WARNING: number = 2;
    public static readonly DANGER: number = 3;
    public static readonly INFORMATIONAL: number = 4;
}
